/* tslint:disable */
/* eslint-disable */
/**
 * Borrower API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BorrowerLoanDetailDto } from './BorrowerLoanDetailDto';
import {
    BorrowerLoanDetailDtoFromJSON,
    BorrowerLoanDetailDtoFromJSONTyped,
    BorrowerLoanDetailDtoToJSON,
    BorrowerLoanDetailDtoToJSONTyped,
} from './BorrowerLoanDetailDto';

/**
 * 
 * @export
 * @interface GetBorrowerLoansResponse
 */
export interface GetBorrowerLoansResponse {
    /**
     * 
     * @type {Array<BorrowerLoanDetailDto>}
     * @memberof GetBorrowerLoansResponse
     */
    loans?: Array<BorrowerLoanDetailDto>;
}

/**
 * Check if a given object implements the GetBorrowerLoansResponse interface.
 */
export function instanceOfGetBorrowerLoansResponse(value: object): value is GetBorrowerLoansResponse {
    return true;
}

export function GetBorrowerLoansResponseFromJSON(json: any): GetBorrowerLoansResponse {
    return GetBorrowerLoansResponseFromJSONTyped(json, false);
}

export function GetBorrowerLoansResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetBorrowerLoansResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'loans': json['loans'] == null ? undefined : ((json['loans'] as Array<any>).map(BorrowerLoanDetailDtoFromJSON)),
    };
}

export function GetBorrowerLoansResponseToJSON(json: any): GetBorrowerLoansResponse {
    return GetBorrowerLoansResponseToJSONTyped(json, false);
}

export function GetBorrowerLoansResponseToJSONTyped(value?: GetBorrowerLoansResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'loans': value['loans'] == null ? undefined : ((value['loans'] as Array<any>).map(BorrowerLoanDetailDtoToJSON)),
    };
}

